import React from "react";
import { FiCompass, FiFileText, FiHome, FiTool } from "react-icons/fi";

const MainPageFeatures = () => {
  return (
    <div className="my-10 grid grid-cols-1 border-y border-gray-200 bg-white md:grid-cols-4">
      <div className="flex justify-start border-b p-5 md:justify-center md:border-b-0 md:border-r md:p-6">
        <div className="flex items-center gap-4 md:gap-5">
          <FiCompass className="text-[#858653] text-[28px] md:text-[34px]" />
          <div>
            <h2 className="text-base font-semibold text-gray-900">Design consultation</h2>
            <p className="text-start text-xs text-gray-600 md:text-sm">
              Understand your space and priorities
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-start border-b p-5 md:justify-center md:border-b-0 md:border-r md:p-6">
        <div className="flex items-center gap-4 md:gap-5">
          <FiFileText className="text-[#858653] text-[28px] md:text-[34px]" />
          <div>
            <h2 className="text-base font-semibold text-gray-900">Transparent estimate</h2>
            <p className="text-xs md:text-sm text-gray-600">Clear scope before work begins</p>
          </div>
        </div>
      </div>
      <div className="flex justify-start border-b p-5 md:justify-center md:border-b-0 md:border-r md:p-6">
        <div className="flex items-center gap-4 md:gap-5">
          <FiTool className="text-[#858653] text-[28px] md:text-[34px]" />
          <div>
            <h2 className="text-base font-semibold text-gray-900">Managed execution</h2>
            <p className="text-start text-xs text-gray-600 md:text-sm">
              Coordinated teams and progress reviews
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-start p-5 md:justify-center md:p-6">
        <div className="flex items-center gap-4 md:gap-5">
          <FiHome className="text-[#858653] text-[28px] md:text-[34px]" />
          <div>
            <h2 className="text-base font-semibold text-gray-900">Complete handover</h2>
            <p className="text-xs md:text-sm text-gray-600">Finishing details checked with care</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPageFeatures;
